
export default class ProjectRules {
    readonly required = [(v: any) => !!v || 'Field is required'];

    readonly name = [
      (v: any) => !!v || 'Field is required',
      (v: any) => (!!v && v.length <= 50) || 'Project name length must be smaller than 50 characters',
      (v: any) => (!!v && v.trim().length !== 0) || 'Project name must be valid',
    ]

    readonly description = [
      (v: any) => !!v || 'Field is required',
      (v: any) => v.length <= 4000 || 'Description length must be smaller than 4000 characters',
    ];

    readonly members = [
      (v: any) => Object.values(v).length > 0 || 'Field is required',
    ];

    readonly nullOrUndefined = [(v: any) => !!(v && v.id) || 'Field is required'];
}
